
import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';

export const RenderRadioGroupField = ({ input, options, meta: { touched, error }, classes, ...custom }) => (
  <React.Fragment>
    <RadioGroup
      {...input}
      {...custom}
    >
      {options.map(option => (
        <FormControlLabel
          key={option.value}
          value={option.value}
          control={<Radio />}
          label={option.text}
        />
      ))}
    </RadioGroup>
    {error && touched && <FormHelperText className={classes.error}>This is required!</FormHelperText>}
  </React.Fragment>
);
